import React, { useState, useEffect } from "react";
import './formServices.css'
import { Input, Button, Form, Typography, Space, Modal } from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";

const { TextArea } = Input;
const { Title } = Typography;

const FormServices = ({ 
    addService, 
    updateService, 
    editingService, 
    setEditingService, 
    isModalVisible, 
    setIsModalVisible 
}) => {
    const [form] = Form.useForm();
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        if (editingService) {
            setIsEditing(true);
            form.setFieldsValue({
                srv_service: editingService.srv_service,
                srv_page_title: editingService.srv_page_title || '',
                srv_page_description: editingService.srv_page_description || ''
            });
        } else {
            setIsEditing(false);
            form.resetFields();
        }
    }, [editingService, form]);

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            
            if (isEditing) {
                updateService(editingService.srv_id, values);
            } else {
                addService(values);
            }
            
            handleCancel();
        } catch (error) {
            console.error('Error al validar campos:', error);
        }
    };

    const handleCancel = () => {
        form.resetFields();
        setEditingService(null);
        setIsEditing(false);
        setIsModalVisible(false);
    };

    return (
        <Modal
            title={isEditing ? 'Editar Servicio' : 'Crear Nuevo Servicio'}
            open={isModalVisible}
            onCancel={handleCancel}
            footer={[
                <Button key="cancel" onClick={handleCancel}>
                    Cancelar
                </Button>,
                <Button 
                    key="submit" 
                    type="primary" 
                    onClick={handleSubmit}
                    icon={isEditing ? <EditOutlined /> : <PlusOutlined />}
                >
                    {isEditing ? 'Actualizar' : 'Crear'}
                </Button>
            ]}
            width={600}
        >
            <Form
                form={form}
                layout="vertical"
                style={{ marginTop: 16 }}
            >
                <Form.Item
                    label="Nombre del Servicio"
                    name="srv_service"
                    rules={[
                        { required: true, message: 'Por favor ingrese el nombre del servicio' },
                        { min: 2, message: 'El nombre debe tener al menos 2 caracteres' }
                    ]}
                >
                    <Input placeholder="Ingrese el nombre del servicio" />
                </Form.Item>

                <Form.Item
                    label="Título de la Página"
                    name="srv_page_title"
                    rules={[
                        { required: true, message: 'Por favor ingrese el título de la página' }
                    ]}
                >
                    <Input placeholder="Ingrese el título que aparecerá en la página" />
                </Form.Item>

                <Form.Item
                    label="Descripción de la Página"
                    name="srv_page_description"
                    rules={[
                        { required: true, message: 'Por favor ingrese la descripción de la página' }
                    ]}
                >
                    <TextArea 
                        rows={4} 
                        placeholder="Ingrese la descripción que aparecerá en la página"
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default FormServices;
